(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else {
    root.LPCSmoocheRouting = api;
    if (typeof document !== 'undefined') {
      var sync = function () {
        if (document.querySelector('[data-smooche-sale-url]')) api.syncLinks(document, root.location);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
      else sync();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function initialOffer(search) {
    return new URLSearchParams(search).get('formula') === 'duo' ? 'duo' : 'solo';
  }

  function initializeOffer(form, search) {
    var offer = initialOffer(search);
    form.querySelectorAll('[name="offer"]').forEach(function (radio) { radio.checked = radio.value === offer; });
    return offer;
  }

  function initialVariant(variants, initialId, search) {
    var requestedId = new URLSearchParams(search).get('variant');
    var selected = variants.find(function (variant) { return String(variant.id) === requestedId; }) || variants.find(function (variant) { return String(variant.id) === String(initialId) && variant.available; }) || variants.find(function (variant) { return variant.available; }) || variants[0];
    var power = new URLSearchParams(search).get('power');
    if (!selected || !/^(15|25)w$/i.test(power || '')) return selected;
    function colorOf(variant) { return variant.color || (variant.options || [])[0] || (variant.title || '').split(' / ')[0]; }
    function powerOf(variant) { return variant.power || (variant.options || [])[1] || (variant.title || '').split(' / ')[1] || '15W'; }
    return variants.find(function (variant) { return variant.available && colorOf(variant) === colorOf(selected) && powerOf(variant).toLowerCase() === power.toLowerCase(); }) || selected;
  }

  function saleUrl(destination, currentUrl, selection) {
    var current, target;
    try {
      current = new URL(currentUrl);
      target = new URL(destination, current.origin);
    } catch (_) { return null; }
    if (!/^https?:$/.test(current.protocol) || target.origin !== current.origin || target.username || target.password) return null;
    if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/[a-z0-9-]+$/.test(target.pathname) || !/^lpc-smooche-[a-z0-9-]+$/.test(target.searchParams.get('view') || '')) return null;
    selection = selection || {};
    var params = new URLSearchParams();
    params.set('view', target.searchParams.get('view'));
    var variant = selection.variant || current.searchParams.get('variant');
    if (variant) params.set('variant', variant);
    var offer = selection.offer || current.searchParams.get('formula') || target.searchParams.get('formula');
    params.set('formula', offer === 'duo' ? 'duo' : 'solo');
    var power = selection.power || target.searchParams.get('power') || current.searchParams.get('power');
    if (/^(15|25)w$/i.test(power || '')) params.set('power', power.toLowerCase());
    current.searchParams.forEach(function (value, key) {
      if (/^utm_/i.test(key) || /^(fbclid|gclid|msclkid)$/i.test(key)) params.set(key, value);
    });
    return target.pathname + '?' + params.toString();
  }

  function packUrl(destination, currentUrl, selection) {
    var current, target;
    try {
      current = new URL(currentUrl);
      target = new URL(destination, current.origin);
    } catch (_) { return null; }
    if (!/^https?:$/.test(current.protocol) || target.origin !== current.origin || target.username || target.password || !/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/configurer-mon-pack$/.test(target.pathname)) return null;
    ['view', 'preview_theme_id', 'preview_script_id', 'previous'].forEach(function (key) { target.searchParams.delete(key); });
    var variant = (selection || {}).variant || current.searchParams.get('variant');
    if (variant) target.searchParams.set('variant', variant);
    current.searchParams.forEach(function (value, key) {
      if (/^utm_/i.test(key) || /^(fbclid|gclid|msclkid)$/i.test(key)) target.searchParams.set(key, value);
    });
    return target.pathname + target.search + target.hash;
  }

  function syncLinks(document, location) {
    var current = new URL(location.href);
    var hero = document.querySelector('.apdp-hero-buy-btn');
    var variant = current.searchParams.get('variant');
    if (hero) {
      try { variant = new URL(hero.href, current.origin).searchParams.get('variant') || variant; } catch (_) {}
    }
    document.querySelectorAll('[data-smooche-sale-url]').forEach(function (link) {
      if (link.dataset.smoochePack === 'true') return;
      var existing;
      try { existing = new URL(link.href, current.origin); } catch (_) { return; }
      var offer = link.dataset.smoocheOffer || current.searchParams.get('formula') || existing.searchParams.get('formula');
      var url = saleUrl(link.dataset.smoocheSaleUrl, current.href, { variant: variant, offer: offer, power: existing.searchParams.get('power') });
      if (url) link.setAttribute('href', url);
    });
    document.querySelectorAll('[data-smooche-pack="true"]').forEach(function (link) {
      var url = packUrl(link.href, current.href, { variant: variant });
      if (url) link.setAttribute('href', url);
    });
  }

  function mountGiftOffer(options) {
    var page = options.page, form = options.form, configurator = options.configurator;
    var latch = page.querySelector('[data-offer-latch]');
    var offer = page.querySelector('#sm-gift-offer');
    if (!latch || !offer) return;
    var choose = offer.querySelector('[data-gift-offer-choose]');
    var handoff = false;
    latch.addEventListener('click', function () {
      if (Array.from(page.querySelectorAll('dialog')).some(function (dialog) { return dialog.open; })) return;
      handoff = false;
      offer.showModal();
    });
    offer.addEventListener('close', function () {
      if (!handoff) latch.focus({ preventScroll: true });
      handoff = false;
    });
    choose.addEventListener('click', function () {
      var duo = form.querySelector('[name="offer"][value="duo"]');
      if (!offer.open || duo.disabled) return;
      handoff = true;
      offer.close();
      latch.focus({ preventScroll: true });
      duo.click();
      form.requestSubmit();
      if (configurator.open) configurator.querySelector('[data-model-toggle]').focus({ preventScroll: true });
    });
  }

  function promo() { return (typeof window !== 'undefined' ? window : globalThis).LPCPromoPricing; }
  function money(cents, currency) {
    return new Intl.NumberFormat(promo()?.config().locale || 'fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
  }
  function renderSoloPrice(page, quote) {
    page.querySelectorAll('[data-solo-original]').forEach(function (el) { el.textContent = money(quote.subtotal, page.dataset.currency); el.hidden = !quote.saving; });
    page.querySelectorAll('[data-solo-badge]').forEach(function (el) { promo().renderTicket(el, {badgeOnly:true, pct:promo().config().promo_solo_pct, hidden:!quote.saving}); });
  }
  function renderSelectionPrice(page, quote, qty) {
    var bf = promo();
    page.querySelectorAll('[data-price-badge]').forEach(function (el) {
      bf.renderTicket(el, {label:'price', size:'md', hidden:!quote?.saving});
    });
  }
  function renderDialogPrice(page, quote, qty) {
    var bf = promo(), active = !!bf?.config().active;
    var dialog = page.querySelector('#sm-configurator');
    if (!dialog) return;
    var label = dialog.querySelector('[data-config-price-label]');
    var defaultLabel = dialog.querySelector('[data-config-default-label]');
    if (defaultLabel) defaultLabel.hidden = active;
    if (label) bf.renderTicket(label, {label:'price', size:'md', pct:bf.rate(qty), tone:qty >= bf.config().promo_pack_min_qty ? 'pack' : 'solo'});
    var configUnit = dialog.querySelector('[data-config-unit]');
    if (active && configUnit) { configUnit.hidden = true; configUnit.textContent = ''; }
    if (active && quote) {
      var original = dialog.querySelector('[data-config-original]');
      original.textContent = money(quote.subtotal, page.dataset.currency);
      original.hidden = !quote.saving;
      dialog.querySelector('[data-config-total]').textContent = money(quote.total, page.dataset.currency);
    }
    var gifts = dialog.querySelector('[data-config-gifts]');
    if (gifts) {
      if (active && !gifts.lpcOriginalPosition) {
        gifts.lpcOriginalPosition = {parent:gifts.parentNode, next:gifts.nextSibling};
        dialog.querySelector('.sm-config-footer').insertBefore(gifts, dialog.querySelector('[data-confirm]'));
      } else if (!active && gifts.lpcOriginalPosition) {
        gifts.lpcOriginalPosition.parent.insertBefore(gifts, gifts.lpcOriginalPosition.next);
        delete gifts.lpcOriginalPosition;
      }
    }
  }

  function renderDuoPrice(page, quote, prices, currency) {
    page.querySelectorAll('[data-duo-badge]').forEach(function (el) {
      promo().renderTicket(el, {badgeOnly:true, pct:promo().rate(2), tone:'pack', hidden:!quote?.saving});
    });
    var unit = page.querySelector('[data-duo-unit], [data-duo-chip]');
    var note = page.querySelector('[data-saving]');
    var configUnit = page.querySelector('[data-config-unit]');
    if (!quote) {
      if (unit) { unit.textContent = promo()?.text('check') || ''; unit.hidden = false; }
      if (note) note.replaceChildren();
      if (configUnit) configUnit.hidden = true;
      return;
    }
    var m = function (cents) { return money(cents, currency); };
    var text = m(Math.round(quote.total / 2)) + ' ' + promo().text('per_charger') + (prices[0] !== prices[1] ? ' ' + promo().text('average') : '');
    if (unit) {
      unit.classList.remove('sm-pill', 'sm-saving-chip');
      unit.classList.add('sm-duo-unit');
      unit.textContent = text;
      unit.hidden = false;
    }
    if (note) {
      if (promo().config().active) {
        note.replaceChildren();
      } else {
        var saving = page.ownerDocument.createElement('strong');
        saving.className = 'sm-duo-saving-amount';
        saving.textContent = quote.saving ? promo().text('saved', {amount:m(quote.saving)}) : '';
        note.replaceChildren(saving);
      }
    }
    if (configUnit) {
      configUnit.textContent = text;
      configUnit.hidden = !!promo()?.config().active || page.querySelector('[name="offer"]:checked')?.value !== 'duo';
      if (promo()?.config().active) configUnit.textContent = '';
    }
  }

  return { renderDialogPrice: renderDialogPrice, renderSelectionPrice: renderSelectionPrice, renderSoloPrice: renderSoloPrice, renderDuoPrice: renderDuoPrice, mountGiftOffer: mountGiftOffer, saleUrl: saleUrl, packUrl: packUrl, syncLinks: syncLinks, initialOffer: initialOffer, initializeOffer: initializeOffer, initialVariant: initialVariant };
});
